export default __webpack_public_path__ + "static/media/redStatus_icon.d657d25b.svg";